import {Action, Dispatch} from 'redux';
import { formatEther, parseEther } from 'ethers';
import {EMISSION_BACKING_ESTIMATE} from '../../../@crema/services/ApiConfig';
import {showError} from '../Common';
import {ApiActionCall, ApiActionTypes} from '../Api';
import {
  FETCH_EMISSION_BACKING_ESTIMATE,
  FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS,
  FETCH_EMISSION_BACKING_ESTIMATE_ERROR,
  EmissionBackingEstimateActionTypes,
} from '../../../types/actions/Token/EmissionBackingEstimate.action';
import {IBackendWallet} from '../../../types/models/BackendWallet';
import {logger} from '../../../shared/logger';

export const fetchEmissionBackingEstimate = (
  totalSupply: string | undefined,
  supplyChange: number,
  targetPrice?: number,
) => async (
  dispatch: Dispatch<ApiActionCall | EmissionBackingEstimateActionTypes>,
) => {
  let resultSupply: string | null;
  if (totalSupply) {
    resultSupply = parseEther((parseFloat(totalSupply) + supplyChange).toString())
      .toString();
  } else {
    resultSupply = null;
  }

  dispatch({type: FETCH_EMISSION_BACKING_ESTIMATE});

  const onSuccess = (payload: IBackendWallet[]) => ({
    type: FETCH_EMISSION_BACKING_ESTIMATE_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_EMISSION_BACKING_ESTIMATE_ERROR});
    dispatch(showError('Failed to fetch pre-emission backing estimate.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: EMISSION_BACKING_ESTIMATE,
      method: 'POST',
      data: {
        totalSupply: resultSupply,
        targetPrice,
      },
      label: 'Fetch pre-emission backing estimate',
      onSuccess,
      onFailure,
    },
  });
};
